import { render, staticRenderFns } from "./ResourceFormLayout.vue?vue&type=template&id=634cd019&scoped=true"
import script from "./ResourceFormLayout.vue?vue&type=script&lang=js"
export * from "./ResourceFormLayout.vue?vue&type=script&lang=js"
import style0 from "./ResourceFormLayout.vue?vue&type=style&index=0&id=634cd019&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634cd019",
  null
  
)

export default component.exports